import { render, staticRenderFns } from "./TrancheMarche.vue?vue&type=template&id=b545bf54&"
import script from "./TrancheMarche.vue?vue&type=script&lang=js&"
export * from "./TrancheMarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports